import {useEffect, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";

export function useAudioStreamURL(id: string | undefined, updatedAt?: string) {
    const [url, setUrl] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!id) return;
        let objectURL: string | null = null;
        setIsLoading(true);
        setError(false);

        platformAPI.get<Blob>(`api/siren/audio-files/${id}/stream`, {responseType: "blob", params: updatedAt ? {v: updatedAt} : undefined})
            .then((res) => {
                objectURL = URL.createObjectURL(res.data);
                setUrl(objectURL);
            })
            .catch(() => setError(true))
            .finally(() => setIsLoading(false));

        return () => {
            if (objectURL) URL.revokeObjectURL(objectURL);
        };
    }, [id, updatedAt]);

    return {url, isLoading, error};
}
